export default {
  items: [
    {
      name: 'ראשי',
      // url: '/dashboard',
      icon: 'icon-home',
      children : [
        {
          name: 'ראשי',
          url: '/dashboard',
          icon: 'icon-home',
        },
        {
          name: 'הגדרות חשבון',
          url: '/profile',
          icon: 'icon-settings'
        },
        {
          name: 'הזמנות',
          url: '/orders',
          icon: 'fa fa-dollar'
        },
      ]
    },
    {
      name: 'יומן',
      url: '/calendar',
      icon: 'icon-calendar'
    },
    {
      name: 'לקוחות',
      // url: '/nutritionist/clients',
      icon: 'icon-people',
      children : [
        {
          name: 'הוסף לקוח חדש',
          url: '/nutritionist/clients/add',
          icon: 'icon-user-follow'
        },
        {
          name: 'לקוחות',
          url: '/nutritionist/clients',
          icon: 'icon-people',
        },
        {
          name: 'SendEmail',
          url: '/send-email',
          icon: 'fa fa-envelope-o'
        },

      ]
    },
    {
        name: 'Weeks',
        icon: 'icon-calendar',
        children: [
            {
                name: 'All Weeks',
                url: '/nutritionist/weeks',
                icon: 'icon-calendar'
            },
            {
                name: 'Client Weeks',
                url: '/nutritionist/client-weeks',
                icon: 'icon-people'
            },
        ]
    },
    {
      name: 'תפריטים',
      // url: '/nutritionist/menus',
      icon: 'icon-layers',
      children: [
        {
          name: 'תפריטים',
          url: '/nutritionist/menus',
          icon: 'icon-layers',          
        },
        {
          name: 'צור תפריט',
          url: '/nutritionist/create-menu',
          icon: 'icon-layers'
        },
      ]
    },
    {
      name: 'Tools',
      icon: 'icon-settings',
      children : [
        {
          name: 'BMI',
          url: '/bmi',
          icon: 'icon-calculator'
        },
        {
          name: 'Calculators',
          url: '/calculator',
          icon: 'icon-calculator'
        },
        {
          name: 'Diets',
          url: '/diets',
          icon: 'icon-layers'
        },
      ]
    },
    {
      name: "B2B",
      icon: 'icon-wallet',
      children: [
        {
          name: 'מומחים',
          url: '/specialists',
          icon: 'icon-briefcase'
        },
        {
          name: 'החנות שלך',
          url: '/shop',
          icon: 'icon-basket-loaded'
        },
      ]
    },
    {
      name: 'News',
      url: '/news',
      icon: 'fa fa-info-circle'
    },
    {
      name: 'עלינו',
      url: '/about',
      icon: 'fa fa-info'
    },
    {
      name: 'How to',
      url: '/how-to',
      icon: 'fa fa-info-circle'
    },
  ]
}
